import React from 'react';
import { ImportJob } from '..';
import * as styles from './ImportJobStatus.module.css';
import ProgressBar from './ProgressBar';
import Icon, { IconStyle } from 'system/base/Icon';

type Props = {
  fileName: ImportJob['file_name'];
  totalFiles: number;
  error?: string | React.ReactNode;
  uploadProgress?: number;
};

const ImportJobStatus = ({
  totalFiles,
  fileName,
  error = '',
  uploadProgress,
}: Props) => {
  const successMessage = `${totalFiles} missing full texts were located in this file.`;

  return (
    <>
      {error && <div className={styles.ImportJobStatus__error}> {error}</div>}
      {!error && (
        <div className={styles.wrapper} data-testid="ImportJobStatus">
          <div className={styles.ImportJobStatus__success}>
            <Icon name="file" iconStyle={IconStyle.Solid} />
            <div>
              <div className={styles.ImportJobStatus__filename}>{fileName}</div>
              <div className={styles.ImportJobStatus__success__message}>
                {successMessage}
              </div>
            </div>
          </div>
          <ProgressBar
            uploadProgress={uploadProgress || 0}
            aria-label="Bulk upload progress"
            aria-valuemin={0}
            aria-valuemax={100}
          />
        </div>
      )}
    </>
  );
};

export default ImportJobStatus;
